"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MolecularSequence_ReferenceSeq = exports.MolecularSequence_ReferenceSeqStrandKind = exports.MolecularSequence_ReferenceSeqOrientationKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_integer_1 = require("../Scalar/RTTI_integer");
var MolecularSequence_ReferenceSeqOrientationKind;
(function (MolecularSequence_ReferenceSeqOrientationKind) {
    MolecularSequence_ReferenceSeqOrientationKind["_sense"] = "sense";
    MolecularSequence_ReferenceSeqOrientationKind["_antisense"] = "antisense";
})(MolecularSequence_ReferenceSeqOrientationKind = exports.MolecularSequence_ReferenceSeqOrientationKind || (exports.MolecularSequence_ReferenceSeqOrientationKind = {}));
var MolecularSequence_ReferenceSeqStrandKind;
(function (MolecularSequence_ReferenceSeqStrandKind) {
    MolecularSequence_ReferenceSeqStrandKind["_watson"] = "watson";
    MolecularSequence_ReferenceSeqStrandKind["_crick"] = "crick";
})(MolecularSequence_ReferenceSeqStrandKind = exports.MolecularSequence_ReferenceSeqStrandKind || (exports.MolecularSequence_ReferenceSeqStrandKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_MolecularSequence_ReferenceSeq = t.recursion('IMolecularSequence_ReferenceSeq', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        chromosome: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        genomeBuild: t.string,
        _genomeBuild: RTTI_Element_1.RTTI_Element,
        orientation: (0, EnumType_1.createEnumType)(MolecularSequence_ReferenceSeqOrientationKind, 'MolecularSequence_ReferenceSeqOrientationKind'),
        _orientation: RTTI_Element_1.RTTI_Element,
        referenceSeqId: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        referenceSeqPointer: RTTI_Reference_1.RTTI_Reference,
        referenceSeqString: t.string,
        _referenceSeqString: RTTI_Element_1.RTTI_Element,
        strand: (0, EnumType_1.createEnumType)(MolecularSequence_ReferenceSeqStrandKind, 'MolecularSequence_ReferenceSeqStrandKind'),
        _strand: RTTI_Element_1.RTTI_Element,
        windowStart: RTTI_integer_1.RTTI_integer,
        _windowStart: RTTI_Element_1.RTTI_Element,
        windowEnd: RTTI_integer_1.RTTI_integer,
        _windowEnd: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_MolecularSequence_ReferenceSeq.js.map